<template>
  <div class="row">
    <div v-if="!isLoading" class="card">
        <div class="withdraw-request">
            <div class="has-pending-request" v-if="hasPendingWithdraw">
                شما یک درخواست برداشت در انتظار تایید دارید. بعد از بررسی آن امکان درخواست جدید خواهید داشت.
            </div>
            <div v-if="!hasPendingWithdraw" class="details">
                <div class="item">
                    <span>موجودی قابل برداشت: </span>
                    <div class="amount" v-html="withdrawData.balance_html"></div>
                </div>
                <div class="item gold" v-if="withdrawData.gold_withdraw">
                    <span>طلای قابل برداشت: </span>
                    <div class="amount" v-html="withdrawData.gold_balance + ' گرم'"></div>
                </div>
            </div>
            <div class="btns" v-if="withdrawData.balance && !hasPendingWithdraw">
                <button href="#" class="btn rial" @click="$emit('withdrawRequest', 'normal')">
                    <span>درخواست</span>
                    <span class="amount" v-html="withdrawData.balance_html"></span>
                </button>
                <button href="#" class="btn gold_wallet" @click="$emit('withdrawRequest', 'gold_wallet')" v-if="withdrawData.gold_withdraw">
                    <span>انتقال</span>
                    <span class="amount" v-html="withdrawData.gold_balance + 'گرم طلا'"></span>
                    <span> به کیف پول</span>
                </button>
                <button href="#" class="btn gold" @click="$emit('withdrawRequest', 'gold')" v-if="withdrawData.gold_withdrawrrr">
                    <span>درخواست فیزیکی</span>
                    <span class="amount" v-html="withdrawData.gold_balance + 'گرم طلا'"></span>
                </button>
            </div>
            <div class="panel-spinner-overlay" v-if="isRequestLoading">
                <b-spinner variant="warning"></b-spinner>
            </div>
        </div>
    </div>
    <div v-else class="card">
        <div class="withdraw-request">

            <div class="details">
                <div class="item">
                    <Skeletor style="width: 100px;"/>
                </div>
                <div class="item gold">
                    <Skeletor style="width: 100px;"/>
                </div>
            </div>
            <div class="btns">
                <Skeletor style="width: 100px;"/>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";
export default {
    name: "withdraw-request",
    props: ['withdrawData', 'isLoading', 'isRequestLoading', 'hasPendingWithdraw'],
    components: {
        Skeletor
    }
}
</script>

<style scoped>

</style>
